module.exports = __webpack_public_path__ + "img/settings_3000.b59d40d5.webp";